import { useRef, useState, useEffect } from "react";
import { FaBars, FaTimes, FaSignOutAlt } from "react-icons/fa";
import { FaFileAlt, FaHistory, FaUsers, FaUser, FaBook, FaTelegram, FaRobot } from "react-icons/fa";
import { GrDocumentConfig } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { IoPersonAddSharp } from "react-icons/io5";
import { FaTasks } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { LuFileScan } from "react-icons/lu";
import { useAuth } from "../auth/Auth";
import axios from 'axios';
import "../header/Header.css";

function Header() {
    const navRef = useRef();
    const { user, logout } = useAuth();
    const isLoggedIn = localStorage.getItem('refreshToken');
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [generalError, setGeneralError] = useState("");

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    logout();
                    navigate('/Login');
                }
                return Promise.reject(error);
            }
        );

        const fetchUsername = async () => {
            if (user?.user_id) {
                try {
                    const userId = user.user_id;
                    const usernameResponse = await axios.get(`https://test2.planfix-to-syrve.com/current-user/${userId}`);
                    setUsername(`<b>${usernameResponse.data.username}</b>`);
                } catch (err) {
                    console.error('Error fetching data:', err);
                    if (err.response && err.response.status === 401) {
                        logout();
                        navigate('/Login');
                    }
                    setGeneralError('Користувач не авторизований');
                }
            }
            setLoading(false);
        };
        
        fetchUsername();
        
        return () => {
            axios.interceptors.response.eject(interceptor);
        };
    }, [user, navigate, logout]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
        if (!menuOpen) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('menu-open');
        } else {
            document.body.style.overflow = '';
            document.body.classList.remove('menu-open');
        }
    };

    const closeMenu = () => {
        setMenuOpen(false);
        document.body.style.overflow = '';
        document.body.classList.remove('menu-open');
    };

    const handleLogout = () => {
        logout();
        setUsername("");
        navigate('/Login');
        closeMenu();
    };

    const handleNavigation = (path) => {
        navigate(path);
        closeMenu();
    };

    if (loading) {
        return <div>Loading...</div>;
    }
  
    if (generalError) {
        return <div>{generalError}</div>;
    }

    return (
        <>
            <header className={`responsive-header ${menuOpen ? "menu-open" : ""}`}>
                <div className="header-container">
                    <div className="header-left">
                        {isLoggedIn && (
                            <button className="menu-toggle" onClick={toggleMenu} aria-label="Menu">
                                <FaBars />
                            </button>
                        )}
                    </div>

                    <div className="header-center">
                        <h2>Система</h2>
                    </div>

                    <div className="header-right">
                        {isLoggedIn && (
                            <button 
                                className="logout-button" 
                                onClick={handleLogout}
                                aria-label="Вийти"
                            >
                                <FaSignOutAlt />
                            </button>
                        )}
                        {!isLoggedIn && (
                            <a href="/Login" className="login-link">Login</a>
                        )}
                    </div>

                    <div className={`mobile-menu-overlay ${menuOpen ? "active" : ""}`} onClick={closeMenu}></div>

                    <nav className={`main-nav ${menuOpen ? "active" : ""}`} ref={navRef}>
                        <button className="close-menu-button" onClick={closeMenu} aria-label="Close menu">
                            <FaTimes />
                        </button>
                        <ul className="nav-links">
                            <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/RestForm');
                                }}>
                                  
                                    <span>Операції</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/Directory');
                                }}>
                                  
                                    <span>Довідник компаній</span>
                                </a>
                            </li>
                              <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/ExcelEditor');
                                }}>
                                  
                                    <span>ExcelEditor</span>
                                </a>
                            </li>
                             <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/PriceChange');
                                }}>
                                  
                                    <span>Зміна ціни</span>
                                </a>
                            </li>
                               <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/FilesManager');
                                }}>
                                  
                                    <span>FilesManager</span>
                                </a>
                            </li>
                             <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/SystemsFabricsManager');
                                }}>
                                  
                                    <span>Fabrick Discount</span>
                                </a>
                            </li>
                             <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/AllOrdersPage');
                                }}>
                                  
                                    <span>Перегляд замовлень</span>
                                </a>
                            </li>
                             <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/EmailSettingsPage');
                                }}>
                                  
                                    <span>Редагування email</span>
                                </a>
                            </li>
                                 <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/ExchangeRateSettings');
                                }}>
                                  
                                    <span>Редагування курсу</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('/UserManagement');
                                }}>
                                   
                                    <span>Управління користувачами</span>
                                </a>
                            </li>
                        </ul>
                        
                        <div className="user-info-in-menu">
                            <div className="username" dangerouslySetInnerHTML={{__html: username}}></div>
                        </div>
                    </nav>
                </div>
            </header>
            <div className="content-spacer"></div>
        </>
    );
}

export default Header;